<!-- Desktop -->

<div class="footer" style="background-color: transparent;">
  <div class="containerOne">
    <div class="socialMedia">
      <div class="socialMediaText">
        <h4>Get In Touch</h4>
      </div>
      <div class="socialMediaIcon">
        <a href="https://www.facebook.com/LineClearExpressMY"><img height="100%"
            src="../../assets/image/ICON-FACEBOOK.png"></a>
        <a href="https://www.instagram.com/lineclearexpress/"><img height="100%"
            src="../../assets/image/ICON-INSTAGRAM.png"></a>
        <a href="https://www.tiktok.com/@lineclearexpress?lang=en"><img height="100%"
            src="../../assets/image/ICON-TIKTOK.png"></a>
        <a href="https://www.youtube.com/channel/UCVkMuHnwc-XKdidhuyRo5Qw"><img height="100%"
            src="../../assets/image/ICON-YOUTUBE.png"></a>
      </div>
    </div>

    <div class="subNow">
      <div class="customHiddenColumn">
        <h4>Subscribe to Our Newsletter</h4>
      </div>
      <div class="customColumn" id="column2">
        <form (submit)="createContact()" class="form-vertical customColumn" role="form">
          <input [(ngModel)]="email" name="email" type="email" id="email" placeholder="Your Email">
          <button style="cursor: pointer;" class="btn" id="sub">Subscribe Now</button>
        </form>
      </div>
    </div>

  </div>
  <div class="line">
  </div>

  <div class="containerTwo">
    <div class="download">
      <div class="downloadTitle">
        <img src="../../assets/image/ICON-OMS APP.png"><span class="downloadText">Download OMS App now!</span>
      </div>
      <div class="downloadHref">
        <a href="https://play.google.com/store/apps/details?id=com.lineclear.oms&pli=1"><img
            src="../../assets/image/OMS-GOOGLEPLAY.png"></a>
        <a href="https://apps.apple.com/my/app/line-clear-oms/id1555210200"><img
            src="../../assets/image/OMS-APPSTORE.png"></a>
      </div>
    </div>

    <div class="patnership">
      <div class="customResize">
        <p style="margin:0;">Looking for patnership opportunities or interested</p>
        <p>to sign up for a Business Account with us?</p>
        <p>Drop us an email at:&nbsp;&nbsp;&nbsp;&nbsp;sales@lineclearexpress.com</p>
      </div>
    </div>
  </div>

  <div class="containerThree">
    <div class="hyperLink">
      <a href="#">About Us</a>
      <div class="verticalBar"></div>
      <a href="javascript:;" (click)="goToPrivacyPolicy()">Privacy Policy</a>
      <div class="verticalBar"></div>
      <a href="#">Company Policy</a>
      <div class="verticalBar"></div>
      <a href="javascript:;" (click)="goToTnc()">Terms and Conditions</a>
    </div>
    <div class="copyright">
      <p> &#169;Copyright 2022 Line Clear. All Rights Reserved.</p>
    </div>
  </div>
</div>